export const DirectDebitOrderSuccessSkeleton = () => {
  return (
    <section className="w-full border rounded-[7px] px-3 lg:px-7 pt-5 text-[#96959F] bg-white animate-pulse">
      <div className="pt-3 space-y-3">
        <div className="w-10 h-10 bg-gray-200 rounded-full mb-2"></div>
        <div className="h-6 w-2/3 bg-gray-200 rounded"></div>
        <div className="h-4 w-1/2 bg-gray-200 rounded"></div>
        <div className="h-4 w-3/4 bg-gray-200 rounded"></div>
        <div className="h-4 w-full bg-gray-200 rounded"></div>
      </div>

      <hr className="my-4 border-t border-gray-300" />

      <div className="space-y-2">
        <div className="h-4 w-1/3 bg-gray-200 rounded"></div>
        <div className="space-y-2 ml-5">
          <div className="h-3 w-11/12 bg-gray-200 rounded"></div>
          <div className="h-3 w-10/12 bg-gray-200 rounded"></div>
        </div>
      </div>

      <hr className="mb-4 mt-6 border-t border-gray-300" />

      <div className="hidden md:block">
        <div className="h-4 w-3/4 bg-gray-200 rounded mb-2"></div>
      </div>

      <div className="md:hidden mt-6 pb-4 space-y-4">
        <div className="h-4 w-2/3 bg-gray-200 rounded"></div>
        <div className="rounded-xl border py-8 shadow-sm bg-white border-[#DEDEDE] space-y-4 px-4">
          <div className="h-4 w-1/2 bg-gray-200 rounded"></div>
          <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
          <div className="h-3 w-1/3 bg-gray-200 rounded"></div>
          <div className="h-4 w-1/2 bg-gray-200 rounded"></div>
        </div>
        <div className="space-y-2">
          <div className="h-3 w-2/3 bg-gray-200 rounded"></div>
          <div className="h-3 w-1/2 bg-gray-200 rounded"></div>
        </div>
      </div>
    </section>
  );
};
